import React, { type FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert } from 'reactstrap';

import type { Features, InitOrganization } from '../../types';

interface Props {
  features: Features;
  currentOrganization: InitOrganization;
}

const AccountNotificationsAlert: FC<Props> = ({
  features,
  currentOrganization,
}) => {
  const allNotificationsOff = features?.notifications?.enabled === false;
  const emailOff =
    !allNotificationsOff && features?.notifications?.enabled_email === false;
  const imOff =
    !allNotificationsOff &&
    ((currentOrganization.instant_messaging === 'slack' &&
      features?.notifications?.enabled_slack === false) ||
      (currentOrganization.instant_messaging === 'msteams' &&
        features?.notifications?.enabled_msteams === false));

  if (!allNotificationsOff && !emailOff && !imOff) {
    return null;
  }

  return (
    <>
      {allNotificationsOff && (
        <Alert color="light" className="mb-2">
          <FormattedMessage
            id="app.views.account.notifications.alert.all_disabled"
            defaultMessage="Your organization has disabled all notifications."
          />
        </Alert>
      )}
      {emailOff && (
        <Alert color="light" className="mb-2">
          <FormattedMessage
            id="app.views.account.notifications.alert.email_disabled"
            defaultMessage="Your organization has disabled email notifications."
          />
        </Alert>
      )}
      {imOff && (
        <Alert color="light" className="mb-2">
          <FormattedMessage
            id="app.views.account.notifications.alert.im_disabled"
            defaultMessage="Your organization has disabled instant messaging notifications."
          />
        </Alert>
      )}
    </>
  );
};

export default React.memo(AccountNotificationsAlert);
